
import { App, defineAsyncComponent } from 'vue'

const FeedbackForm = defineAsyncComponent(() => import('./Feedback.vue'))
const FeedbackFindDoctorForm = defineAsyncComponent(() => import('./FeedbackFindDoctor.vue'))
const SubscribeForm = defineAsyncComponent(() => import('./Subscribe.vue'))
const ImpressionForm = defineAsyncComponent(() => import('./Impression.vue'))
const RatingForm = defineAsyncComponent(() => import('./Rating.vue'))
const FeedbackCallbackForm = defineAsyncComponent(() => import('./FeedbackCallback.vue'))
const FeedbackWritebackForm = defineAsyncComponent(() => import('./FeedbackWriteback.vue'))

const install = (app: App<Element>, postfix = 'Form'): void => {
  app
    .component(`Feedback${postfix}`, FeedbackForm)
    .component(`FeedbackFindDoctor${postfix}`, FeedbackFindDoctorForm)
    .component(`Subscribe${postfix}`, SubscribeForm)
    .component(`Impression${postfix}`, ImpressionForm)
    .component(`Rating${postfix}`, RatingForm)
    .component(`FeedbackCallback${postfix}`, FeedbackCallbackForm)
    .component(`FeedbackWriteback${postfix}`, FeedbackWritebackForm)
}

export default {
  install,
}
